<template>
  <el-popover v-bind="$attrs" trigger="hover" popper-class="qrcode-popover-container" width="160px">
    <div class="qrcode-popover-content">
      <div ref="image" class="qrcode-popover-image"></div>
      <p class="qrcode-popover-tips">{{ tips }}</p>
    </div>
    <slot></slot>
    <template slot="reference">
      <slot name="reference"></slot>
    </template>
  </el-popover>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  name: 'QrcodePopover',
  props: {
    url: String,
    tips: String
  },
  data() {
    return {}
  },
  watch: {
    url: {
      handler(val) {
        if (val) {
          this.initQrcode()
        }
      },
      immediate: true
    }
  },
  methods: {
    async initQrcode() {
      await this.$nextTick()
      /* eslint-disable */
      new QRCode(this.$refs.image, {
        width: 240,
        height: 240, // 高度
        text: this.url
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.qrcode-popover-content {
  overflow: hidden;
  width: 120px;

  .qrcode-popover-image {
    width: 120px;
    height: 120px;
    /deep/ img {
      width: 100%;
      height: 100%;
    }
  }
  .qrcode-popover-tips {
    padding: 0;
    margin: 0;
    width: 120px;
    text-align: center;
    font-size: 14px;
    line-height: 14px;
    margin: 13px 0;
  }
}
</style>
<style lang="scss">
.qrcode-popover-container {
  width: 160px;
  padding: 20px 20px 0 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.05);
}
</style>



// WEBPACK FOOTER //
// src/components/QrcodePopover/index.vue